import React from "react";
import { PartsTable } from "./NpdShared";

const PartsView = ({ app }) => {
  const { isAdmin, me, lines, parts, buyers, today, go, openPart, advance } = app;
  return (
    <>
      <h2>Products / Parts</h2>
      <p className="sub">All sourcing items across assembly lines</p>
      <div className="tools">
        <button className="btn p" onClick={() => go("add")}>Add part</button>
      </div>
      <div className="panel">
        <PartsTable list={parts} showLine today={today} isAdmin={isAdmin} me={me} buyers={buyers} lines={lines}
          engFilter lineFilter onOpen={openPart} onAdvance={advance} />
      </div>
    </>
  );
};

export default PartsView;
